import promiseIdle from './lib/promise-idle';
import ready from './lib/ready';
import BreakpointObserver from './lib/BreakpointObserver';
import ToggleArea from './lib/ToggleArea';
import {SizeTransitionBehavior} from './lib/ToggleArea_SizeBehavior';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import nodeFromTemplate from './lib/node-from-template';
import {mutate} from './lib/promise-fastdom';

ready()
    .then(promiseIdle())
    .then(function () {

        let readyPromise;

        const toggle = nodeFromTemplate('accordion-toggle-tpl');

        const accordions = document.querySelectorAll('.mapiece-accordion');

        accordions.length && (new BreakpointObserver('accordion')).observe(query => {
            readyPromise = Promise.resolve(readyPromise)
                .then((reset) => typeof reset === 'function' ? reset() : null)
                .then(() => query.matches || init());
        });

        function init() {
            return Promise.all(
                Array.prototype.map.call(accordions, function (accordion) {
                    return Promise.all(
                        Array.prototype.map.call(accordion.querySelectorAll(':scope > .mapiece-title-text'), item => {
                            return Promise.resolve().then(mutate(() => {
                                const clone = toggle.cloneNode(true);
                                item.querySelector('.mapiece-title-text__title').insertAdjacentElement('afterend', clone);
                                return (new ToggleArea(item.querySelector('.mapiece-title-text__contents'), 'accordion', [
                                    new ButtonBehavior(clone, {
                                        closeOnLinkClick: false,
                                        closeOnOutsideClick: false,
                                        focusAreaOnOpen: true,
                                        jail: false
                                    }),
                                    new SizeTransitionBehavior(['height']),
                                ]));
                            }));
                        })
                    );
                }))
                .then((accordions) => function reset() {
                    return Promise.all(
                        accordions.map(function (accordion) {
                            return Promise.all(
                                accordion.map(function (ta) {
                                    return Promise.resolve().then(mutate(() => {
                                        const toggle = ta.area().parentNode.querySelector('.accordion-toggle');
                                        toggle.parentNode.removeChild(toggle);
                                        return ta.destroy();
                                    }));
                                })
                            );
                        })
                    );
                });
        }

    });
